export default {
  green110:"#00A52A",
  green110_dark:"#4DBF69",
  green100:"#00BB30",
  green100_dark:"#30BF54",
  green70:"#4CCF6E",
  green70_alpha:"rgba(0, 187, 48, 0.7)",
  green70_dark:"#2C9046",
  green70_dark_alpha:"rgba(48, 191, 84, 0.7)",
  green40:"#99E4AC",
  green40_alpha:"rgba(0, 187, 48, 0.4)",
  green40_dark:"#286138",
  green40_dark_alpha:"rgba(48, 191, 84, 0.4)",
  green10:"#E5F8EA",
  green10_alpha:"rgba(0, 187, 48, 0.1)",
  green10_dark:"#343937",
  green10_dark_alpha:"rgba(209, 255, 209, 0.1)",
  black90:"#191919",
  black90_alpha:"black",
  black90_dark:"#FFFFFF",
  black90_dark_alpha:"white",
  black80:"#191919",
  black80_alpha:"rgba(0, 0, 0, 0.9)",
  black80_dark:"#AEADB3",
  black80_dark_alpha:"rgba(255, 255, 255, 0.7)",
  black50:"#818181",
  black50_alpha:"rgba(0, 0, 0, 0.5)",
  black50_dark:"#87878C",
  black50_dark_alpha:"rgba(255, 255, 255, 0.5)",
  black25:"#B2B2B2",
  black25_alpha:"rgba(0, 0, 0, 0.3)",
  black25_dark:"#626166",
  black25_dark_alpha:"rgba(255, 255, 255, 0.3)",
  black12:"#DFDFDF",
  black12_alpha:"rgba(0, 0, 0, 0.12)",
  black12_dark:"#3B3B40",
  black12_dark_alpha:"rgba(255, 255, 255, 0.1)",
  black8:"#F2F2F2",
  black8_alpha:"rgba(0, 0, 0, 0.05)",
  black8_dark:"#3B3B40",
  black8_dark_alpha:"rgba(255, 255, 255, 0.1)",
  black3:"#F7F7F7",
  black3_alpha:"rgba(0, 0, 0, 0.03)",
  black3_dark:"#2F2F33",
  black3_dark_alpha:"rgba(255, 255, 255, 0.05)",
  black0:"#FFFFFF",
  black0_alpha:"#FFFFFF",
  black0_dark:"#232326",
  black0_dark_alpha:"rgba(255, 255, 255, 0.05)",
  black_empty:"#F2F2F2",
  black_empty_dark:"#17171A",
  black70:"#494949",
  black70_alpha:"rgba(0, 0, 0, 0.7)",
  black70_dark:"#AEADB3",
  black70_dark_alpha:"rgba(255, 255, 255, 0.7)",
  black0_button:"#FFFFFF",
  black0_button_alpha:"white",
  black0_button_dark:"#3B3B40",
  blue100:"#2384E8",
  blue100_dark:"#2691FF",
  blue110:"#0C61B9",
  blue110_dark:"#499EF2",
  blue70:"#65A8EE",
  blue70_alpha:"rgba(35, 132, 232, 0.7)",
  blue70_dark:"#2580BE",
  blue70_dark_alpha:"rgba(38, 145, 255, 0.7)",
  blue40:"#A7CEF6",
  blue40_alpha:"rgba(35, 132, 232, 0.4)",
  blue40_dark:"#274B72",
  blue40_dark_alpha:"rgba(38, 145, 255, 0.4)",
  blue10:"#E9F2FC",
  blue10_alpha:"rgba(35, 132, 232, 0.1)",
  blue10_dark:"#31353C",
  blue10_dark_alpha:"rgba(179, 216, 255, 0.1)",
  orange100:"#EE5400",
  orange100_dark:"#E65F2E",
  orange110:"#CA4500",
  orange110_dark:"#D96136",
  orange70:"#F3874C",
  orange70_alpha:"rgba(238, 84, 0, 0.7)",
  orange70_dark:"#AB4D2B",
  orange70_dark_alpha:"rgba(230, 95, 46, 0.7)",
  orange40:"#F8BB99",
  orange40_alpha:"rgba(238, 84, 0, 0.4)",
  orange40_dark:"#713B28",
  orange40_dark_alpha:"rgba(230, 95, 46, 0.4)",
  orange10:"#FDEDE5",
  orange10_alpha:"rgba(238, 84, 0, 0.1)",
  orange10_dark:"#393230",
  orange10_dark_alpha:"rgba(255, 190, 140, 0.1)",
  apricot100:"#FF9900",
  apricot100_dark:"#F29418",
  apricot110:"#D57B0F",
  apricot110_dark:"#D9A14C",
  apricot70:"#FFB74C",
  apricot70_alpha:"rgba(255, 153, 0, 0.7)",
  apricot70_dark:"#B3721C",
  apricot70_dark_alpha:"rgba(242, 148, 24, 0.7)",
  apricot40:"#FFD596",
  apricot40_alpha:"rgba(255, 153, 0, 0.4)",
  apricot40_dark:"#765020",
  apricot40_dark_alpha:"rgba(242, 148, 24, 0.4)",
  apricot10:"#FFF4E5",
  apricot10_alpha:"rgba(255, 153, 0, 0.1)",
  apricot10_dark:"#393531",
  apricot10_dark_alpha:"rgba(255, 208, 143, 0.1)",
  red110:"#B4000E",
  red110_dark:"#E65C67",
  red100:"#DF1010",
  red100_dark:"#E63948",
  red70:"#FF5757",
  red70_alpha:"rgba(223, 16, 16, 0.7)",
  red70_dark:"#AB323D",
  red70_dark_alpha:"rgba(230, 57, 72, 0.7)",
  red40:"#FF9F9F",
  red40_alpha:"rgba(223, 16, 16, 0.4)",
  red40_dark:"#712C33",
  red40_dark_alpha:"rgba(230, 57, 72, 0.4)",
  red10:"#FFE7E7",
  red10_alpha:"rgba(223, 16, 16, 0.1)",
  red10_dark:"#392F31",
  red10_dark_alpha:"rgba(255, 162, 153, 0.1)",
  white100:"#FFFFFF",
  white70:"rgba(255, 255, 255, 0.7)",
  white50:"rgba(255, 255, 255, 0.5)",
  white30:"rgba(255, 255, 255, 0.3)",
  white10:"rgba(255, 255, 255, 0.1)",
}